import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import classnames from 'classnames';
import { useTranslation, withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import OrderModule from 'components/modules/orders/Module';
import ExceptionsActionCreators from 'actions/ExceptionsActionCreators';
import CargomaticPane from 'components/v2/pane';
import SessionStore from 'stores/SessionStore';
import ExceptionStore from 'stores/ExceptionStore';
import Container from 'components/v2/container';
import DataPoller from 'components/ui/DataPoller';
import DataList from 'components/ui/DataList';
import CustomerSearch from 'components/site/customer-search';
import { getColumns } from './OrderMapping';
import { getChangesColumns } from './ChangesMapping';
import ErrorAlert from '../../ui/ErrorAlert';
import OrderSearch from '../../site/order-search';
import Badge from '../../ui/Badge';
const OrderChangeException = (props) => {
    const { exception: { meta: { changes }, message, }, } = props;
    const { t } = useTranslation();
    return (React.createElement("div", { className: "p-8" },
        message && (React.createElement("div", { className: "mb-2" },
            React.createElement(ErrorAlert, { title: t('CHANGE_REQUEST_FAILED_REASON') }, message))),
        React.createElement("h3", { className: "mb-4" }, t('CHANGE_REQUEST')),
        React.createElement("p", { className: "mb-4" }, t('CHANGE_REQUEST_RECEIVED')),
        React.createElement("div", { className: "text-sm border-t border-b border-solid border-grey" },
            React.createElement(DataList, { showHeaders: true, hover: true, striped: true, data: changes, columns: getChangesColumns() })),
        React.createElement("div", { className: "flex justify-end py-4" },
            React.createElement("button", { type: "button", className: "mr-2 button button-hollow-red", onClick: props.onHide }, t('CLOSE')),
            React.createElement("button", { type: "button", className: "button button-green", onClick: () => props.onResolve(props.exception._id) }, t('RESOLVE')))));
};
OrderChangeException.propTypes = {
    exception: PropTypes.shape({
        _id: PropTypes.string,
        message: PropTypes.string,
        meta: PropTypes.shape({
            changes: PropTypes.array,
        }),
    }),
    onHide: PropTypes.func.isRequired,
    onResolve: PropTypes.func.isRequired,
};
const GenericOrderException = (props) => {
    let changes = [];
    const { t } = useTranslation();
    if (props.exception && props.exception.meta) {
        changes = props.exception.meta.changes;
    }
    return (React.createElement("div", { className: "p-8" },
        React.createElement("h3", null, t('GENERIC_EXCEPTION')),
        React.createElement("div", { className: "py-4" },
            React.createElement("span", null, t('PROCESSING_DATA_ERROR'))),
        React.createElement("div", { className: "text-sm border-t border-b border-solid border-grey" },
            React.createElement(DataList, { showHeaders: true, hover: true, striped: true, data: changes, columns: getChangesColumns() })),
        React.createElement("div", { className: "flex justify-end py-4" },
            React.createElement("button", { type: "button", className: "mr-2 button button-hollow-red", onClick: props.onHide }, t('CLOSE')),
            React.createElement("button", { type: "button", className: "button button-green", onClick: () => props.onResolve(props.exception._id) }, t('RESOLVE')))));
};
GenericOrderException.propTypes = {
    exception: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        meta: PropTypes.shape({
            changes: PropTypes.array,
        }),
    }),
    onHide: PropTypes.func.isRequired,
    onResolve: PropTypes.func.isRequired,
};
class OrderExceptions extends Component {
    constructor(props) {
        super(props);
        this.handleSelectOrder = (_value, order) => {
            this.setState((prevState) => {
                const { filters: currentFilters, filterMetadata: currentFilterMetadata } = prevState;
                const filters = Object.assign(Object.assign({}, currentFilters), { orderId: order._id, page: 1 });
                const filterMetadata = Object.assign(Object.assign({}, currentFilterMetadata), { order: order.order_id });
                return {
                    filters,
                    filterMetadata,
                };
            }, this.queryExceptions);
        };
        this.handleOrderClick = (row, e) => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({
                showExceptionPane: false,
                showOrderPane: true,
                order_oid: row.order._id,
            });
        };
        this.onChange = () => {
            const exceptions = _.sortBy(ExceptionStore.getAllExceptions(), '_id');
            const totalPages = ExceptionStore.getTotalPages();
            this.setState({ exceptions, totalPages });
        };
        this.queryExceptions = () => {
            const filters = Object.assign({}, this.state.filters);
            if (!filters.shipper) {
                delete filters.shipper;
            }
            if (!filters.orderId) {
                delete filters.orderId;
            }
            ExceptionsActionCreators.getOrderExceptions(filters);
        };
        this.onPaginationSelect = (page) => {
            this.setState((prevState) => {
                return {
                    filters: Object.assign(Object.assign({}, prevState.filters), { page }),
                };
            }, this.queryExceptions);
        };
        this.onHideExceptionPane = () => {
            this.setState({ showExceptionPane: false });
        };
        this.onRowSelect = (row, isSelected) => {
            const selected = isSelected ? [row._id] : [];
            const update = {
                selected,
                showExceptionPane: selected.length === 1,
            };
            return this.setState(update);
        };
        this.shouldRowHighlight = (row) => {
            if (!row)
                return;
            const { shipper, release_time } = row;
            const status = shipper && shipper.status ? shipper.status : '';
            const diff = moment().diff(moment(release_time), 'hours');
            const classNames = classnames({
                'bg-blue-100': ['Service Watch', 'New Customer'].indexOf(status) > -1 && !row.on_hold,
                'bg-yellow-200': row.on_hold,
                'bg-red-50': diff >= 1 && diff < 2 && !row.on_hold,
                'bg-red-100': diff >= 2 && diff < 3 && !row.on_hold,
                'bg-red-200': diff >= 3 && !row.on_hold,
                'cursor-pointer': true,
            });
            return classNames;
        };
        this.onHideOrderPane = () => {
            this.setState({ showOrderPane: false });
        };
        this.resolveException = (id) => {
            ExceptionsActionCreators.addResolution(id, 'Change Accepted', {});
            this.setState({ showExceptionPane: false }, () => {
                setTimeout(this.queryExceptions, 250);
            });
        };
        this.getSelectedExceptionComponent = () => {
            const { selected, exceptions } = this.state;
            if (!selected || selected.length === 0)
                return;
            const exception = _.findWhere(exceptions, { _id: selected[0] });
            if (exception._type !== 'generic') {
                return (React.createElement(OrderChangeException, { onResolve: this.resolveException, exception: exception, onHide: this.onHideExceptionPane }));
            }
            return (React.createElement(GenericOrderException, { onResolve: this.resolveException, exception: exception, onHide: this.onHideExceptionPane }));
        };
        this.handleRemoveOrder = () => {
            this.setState((prevState) => {
                const { filters: currentFilters, filterMetadata: currentFilterMetadata } = prevState;
                const filters = Object.assign(Object.assign({}, currentFilters), { orderId: null, page: 1 });
                const filterMetadata = Object.assign(Object.assign({}, currentFilterMetadata), { order: null });
                return {
                    filters,
                    filterMetadata,
                };
            }, this.queryExceptions);
        };
        this.handleRemoveShipper = () => {
            this.setState((prevState) => {
                const { filters: currentFilters, filterMetadata: currentFilterMetadata } = prevState;
                const filters = Object.assign(Object.assign({}, currentFilters), { shipper: null, page: 1 });
                const filterMetadata = Object.assign(Object.assign({}, currentFilterMetadata), { shipper: null });
                return {
                    filters,
                    filterMetadata,
                };
            }, this.queryExceptions);
        };
        this.handleSelectShipper = (_label, item) => {
            this.setState((prevState) => {
                const { filters: currentFilters, filterMetadata: currentFilterMetadata } = prevState;
                const filters = Object.assign(Object.assign({}, currentFilters), { shipper: item._id, page: 1 });
                const filterMetadata = Object.assign(Object.assign({}, currentFilterMetadata), { shipper: item.name });
                return {
                    filters,
                    filterMetadata,
                };
            }, this.queryExceptions);
        };
        const user = SessionStore.getUser();
        this.state = {
            user,
            selected: [],
            order_oid: null,
            showExceptionPane: false,
            showOrderPane: false,
            totalPages: 0,
            filters: {
                _type: 'order',
                sort_by: '_id',
                order: 'asc',
                orderId: null,
                shipper: null,
                page: 1,
                per_page: 20,
            },
            filterMetadata: {
                shipper: '',
                order: '',
            },
            exceptions: [],
        };
    }
    componentDidMount() {
        ExceptionStore.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        ExceptionStore.removeChangeListener(this.onChange);
    }
    formatColumnDefs(columns) {
        return columns.map((c) => {
            if (c.dataField.includes('order_id')) {
                c.formatExtraData = {
                    onClick: this.handleOrderClick,
                };
            }
            return c;
        });
    }
    render() {
        const { t } = this.props;
        if (!this.state.user)
            return React.createElement("div", null, t('LOADING'));
        const columnDefs = this.formatColumnDefs(getColumns());
        return (React.createElement(Container, { className: "py-8 min-h-screen" },
            React.createElement(DataPoller, { action: this.queryExceptions }),
            React.createElement("header", { className: "" },
                React.createElement("h3", { className: "mb-4 text-xl font-medium" }, t('ORDER_EXCEPTIONS'))),
            React.createElement("div", { className: "px-4 -mx-4" },
                React.createElement("div", { className: "flex flex-wrap filters-wrapper" },
                    React.createElement("div", { className: "w-full px-4 mb-4 md:w-1/3" },
                        React.createElement("h4", { className: "mb-2 mb-4 text-lg" }, t('SEARCH_BY_ORDER_ID')),
                        !this.state.filters.orderId && (React.createElement(OrderSearch, { onSelect: this.handleSelectOrder })),
                        this.state.filters.orderId && (React.createElement("div", { className: "flex-grow-0 flex-shrink-0 inline-block" },
                            React.createElement(Badge, { showDelete: true, onClick: this.handleRemoveOrder, color: "green", text: this.state.filterMetadata.order })))),
                    React.createElement("div", { className: "w-full px-4 mb-4 md:w-1/3" },
                        React.createElement("h4", { className: "mb-4 text-lg" }, titleize(t('SHIPPER', { count: 1 }))),
                        !this.state.filters.shipper && (React.createElement(CustomerSearch, { clearOnSelect: true, type: "shippers", onSelect: this.handleSelectShipper, placeholder: t('SEARCH_FOR_SHIPPER_PLACEHOLDER') })),
                        this.state.filters.shipper && (React.createElement("div", { className: "flex-grow-0 flex-shrink-0 inline-block" },
                            React.createElement(Badge, { showDelete: true, onClick: this.handleRemoveShipper, color: "green", text: this.state.filterMetadata.shipper })))))),
            React.createElement("div", { className: "w-full" },
                React.createElement(DataList, { shouldRowHighlight: this.shouldRowHighlight, showHeaders: true, paginate: true, select: true, hover: true, clickToSelect: true, selectMode: "radio", data: this.state.exceptions, columns: columnDefs, total: ExceptionStore.getTotalCount(), perPage: this.state.filters.per_page, pages: this.state.totalPages, page: this.state.filters.page, onPaginationSelect: this.onPaginationSelect, selected: this.state.selected, onSelect: this.onRowSelect }),
                React.createElement("div", { id: "pane-container" }),
                this.state.showExceptionPane && (React.createElement(CargomaticPane, { show: this.state.showExceptionPane, title: t('EXCEPTION_DETAILS'), onHide: this.onHideExceptionPane, renderBody: this.getSelectedExceptionComponent, location: "right", className: "sm:w-1/2 sm:max-w-none" })),
                this.state.showOrderPane && (React.createElement(CargomaticPane, { show: true, location: "left", title: titleize(t('DETAIL', { count: 1 })), onHide: this.onHideOrderPane, renderBody: () => (React.createElement("div", { className: "p-6" },
                        React.createElement(OrderModule, { hideMap: true, id: this.state.order_oid }))), width: 0.8 })))));
    }
}
export default withTranslation()(OrderExceptions);
